(function () {
    'use strict';

    angular
        .module('app')
        .controller('MoveGroupController', MoveGroupController);

    MoveGroupController.$inject = ['debug', 'API', 'i18n', '$scope',];

    function MoveGroupController(debug, API, i18n, $scope) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.submit = submit;
        vm.loading = false;
        vm.schoolsList = [];

        activate();

        function activate() {
            loadSchools();
            vm.schoolId = $scope.placeholders.schoolId;
            vm.group = $scope.placeholders.group;
            vm.oldSchool = vm.group.fk_school_id;
        }

        function submit() {
            vm.group.fk_school_id = vm.schoolIdToMoveTo;
            vm.group.$save()
            .then(function (response) {
                if (response.fk_school_id !== vm.oldSchool) {
                    window.toast({ message: i18n.get('SCHOOL_MOVED'), autoRemoveTime: 5000, type: 'success' });
                    vm.resolve(response);
                } else {
                    window.toast({ message: i18n.get('FAILED'), type: 'danger' });
                    vm.cancel(response);
                }
            }, function (response) {
                window.toast({ message: i18n.get('FAILED'), type: 'danger' });
                vm.cancel(response);
            });
        }

        function loadSchools() {
            vm.loading = true;
            API.School.search({
                'per-page': 0,
                'status': 'verified',
                'sort': 'name',
                'fields': 'id,name,disctrict'
            })
                .$promise
                .then(function (list) {
                    angular.forEach(list.items, function (school) {
                        if (school.id !== vm.schoolId) {
                            vm.schoolsList.push({
                                value: school.id,
                                label: school.name,
                                subLabel: school.district,
                            });
                        }
                    });
                }, function () {
                    debug.error('Could not load schools.');
                }).finally(function() {
                    vm.loading = false;
                });
        }

    }
})();